import React from 'react';
import { Row, Col } from 'react-bootstrap';

export const POLICY_SUM_INSURED_FIELDS = [
    { key: 'daily_sum_insured_maintain', label: 'Montant journalier – Maintien' },
    { key: 'daily_sum_insured_cancellation', label: 'Montant journalier – Annulation' },
    { key: 'total_sum_insured_maintain', label: 'Montant total – Maintien' },
    { key: 'total_sum_insured_cancellation', label: 'Montant total – Annulation' },
];

export const displaySumInsured = (value) => {
    if (value == null || value === '') return '—';
    return value;
};

export const pickPolicySumInsured = (source = {}) => ({
    daily_sum_insured_maintain: source.daily_sum_insured_maintain ?? null,
    daily_sum_insured_cancellation: source.daily_sum_insured_cancellation ?? null,
    total_sum_insured_maintain: source.total_sum_insured_maintain ?? null,
    total_sum_insured_cancellation: source.total_sum_insured_cancellation ?? null,
});

const PolicySumInsuredRows = ({
    source,
    Label,
    Value,
    colMd = 6,
    className = 'mb-2 mt-2',
}) => (
    <Row className={className}>
        {POLICY_SUM_INSURED_FIELDS.map(({ key, label }) => (
            <Col md={colMd} key={key}>
                <Label>{label}</Label>
                <Value>{displaySumInsured(source?.[key])}</Value>
            </Col>
        ))}
    </Row>
);

export default PolicySumInsuredRows;
